module.exports = __webpack_public_path__ + "static/img/tips.be3b216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fan/tips.png
// module id = BUQd
// module chunks = 1